// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4002';

export { API_BASE_URL };